// Web/desktop fallback: nothing to clear
export async function clearAllCookies(): Promise<void> {
  return;
}


